import { Container } from "react-bootstrap";
import Counter from "./features/counter/Counter";
import axios from "axios";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NotificationPage from "./components/Push_notification";
import { Link, useNavigate } from "react-router-dom";
import { Routes, Route, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ReservationCustomersMenuScreen from "./screens/ReservationCustomersMenuScreen";
import ReservationFromRestaurantScreen from "./screens/ReservationFromRestaurantScreen";
import ReservationScreen from "./screens/ReservationScreen";
import ProfileScreen from "./screens/ProfileScreen";
import CreateAccountScreen from "./screens/CreateAccountScreen";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import RestaurantSettingsUpdate from "./screens/RestaurantSettingsUpdate";
import RestaurantZonesTablesManagement from "./screens/RestaurantZonesTablesManagement";
import RestaurantTimeManagement from "./screens/RestaurantTimeManagement";
import RestaurantCreation from "./screens/RestaurantCreation";
import RestaurantClients from "./screens/RestaurantClients";
import ManagersCreationScreen from "./screens/ManagersCreationScreen";
import PlaceDesignScreen from "./screens/PlaceDesignScreen";
import ConfirmNotification from "./screens/ConfirmNotification";
import Notifications from "./screens/Notifications";
import AccountRecovery from "./screens/AccountRecovery";
import PasswordRecoveryChange from "./screens/PasswordRecoveryChange";
import FiscalAdress from "./screens/FiscalAdress";
import ChoosePlanAndPay from "./screens/ChoosePlanAndPay";
import DeleteClientInfo from "./screens/DeleteClientInfo";
import RestaurantInfoUpdate from "./screens/RestaurantInfoUpdate";
import SubscriptionManagement from "./screens/SubscriptionManagement";
import Time from "./screens/Time";
import styled from "styled-components";
import { useState, useEffect } from "react";
import ConnectionStatus from "./components/ConectionStatus";

import { fetchReservationActive } from "./actions/reservationsActions";

export const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Styled container for Routes (see above)

const StyledRoutesContainer = styled.div`
  max-height: 100vh;
  flex: 1;
  margin: 0;
  padding: 0;
  font-family: "Poppins";
  overflow-y: auto;
  overflow-x: hidden;

  /* Style the scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
  @media (max-width: 768px) {
    padding-top: ${(props) => (props.noPadding ? "0" : "60px")};
  }
`;

function App() {
  const location = useLocation();
  const id = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isPaddingTop, setIsPaddingTop] = useState(true); // optional local state if needed

  const isReservationActive = useSelector((state) => state.reservationActive);
  const { isActive } = isReservationActive;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // Define an array of paths where you don't want the mobile padding
  const noPaddingPaths = [
    "/c",
    "/customer_reservation_menu",
    "/login",
    "/recovery_code",
  ];

  // Check if the current pathname starts with any of the noPaddingPaths
  const disablePadding = noPaddingPaths.some((path) =>
    location.pathname.startsWith(path),
  );

  const redirect_to_login = !disablePadding && !location.pathname !== "/";

  useEffect(() => {
    if (!userInfo && redirect_to_login) {
      navigate(`/login/${"null"}/${"null"}`);
    }
  }, [dispatch, navigate, userInfo]);

  return (
    <div className="App">
      {/* Optionally render NotificationPage or other components */}
      <main>
        <ConnectionStatus />
        <div style={{ display: "flex", flexWrap: "nowrap", width: "100%" }}>
          {isActive ? null : <Header />}
          <StyledRoutesContainer noPadding={disablePadding}>
            <Routes>
              <Route
                path="/login/:username/:password"
                element={<LoginScreen />}
              />
              <Route
                path="/reservationfromrestaurant/:restaurant_id/:date/:status"
                element={<ReservationFromRestaurantScreen />}
              />
              <Route
                path="/delete_client_info/:token/:phone_number/"
                element={<DeleteClientInfo />}
              />
              <Route
                path="/reservations/:restaurant_id/:from_whom/:token"
                element={<ReservationScreen />}
              />
              <Route
                path="/RestaurantZonesTablesManagement/:reservation_id"
                element={<RestaurantZonesTablesManagement />}
              />
              <Route
                path="/c/:token/:change_status"
                element={<ReservationCustomersMenuScreen />}
              />
              <Route
                path="/customer_reservation_menu/:token/:change_status"
                element={<ReservationCustomersMenuScreen />}
              />
              <Route
                path="/RestaurantTimeManagement/:restaurant_id"
                element={<RestaurantTimeManagement />}
              />
              <Route path="/time/:restaurant_id" element={<Time />} />
              <Route
                path="/restaurantclients/:restaurant_id"
                element={<RestaurantClients />}
              />
              <Route
                path="/restaurant_creation/:tutorial/:step/:restaurant_id"
                element={<RestaurantCreation />}
              />
              <Route path="/yo" element={<Counter />} />
              <Route
                path="/profile/update/:first_time_manager_login"
                element={<ProfileScreen />}
              />
              <Route path="/register" element={<CreateAccountScreen />} />
              <Route
                path="/manager_account_creation"
                element={<ManagersCreationScreen />}
              />
              <Route
                path="/place_design/:restaurant_id"
                element={<PlaceDesignScreen />}
              />
              <Route
                path="/notifications/:token/:email_phone/:restaurant_name"
                element={<ConfirmNotification />}
              />
              <Route
                path="/restaurant_notifications/:restaurant_id"
                element={<Notifications />}
              />
              <Route path="/passwordRecovery" element={<AccountRecovery />} />
              <Route
                path="/recovery_code/:recovery_code"
                element={<LoginScreen />}
              />
              <Route path="/FiscalAddress" element={<FiscalAdress />} />
              <Route
                path="/pick_plan_and_pay/:restaurant_id"
                element={<ChoosePlanAndPay />}
              />
              <Route
                path="/restaurant_info_update/:restaurant_id"
                element={<RestaurantInfoUpdate />}
              />
              <Route
                path="/restaurantsettingsupdate/:restaurant_id"
                element={<RestaurantSettingsUpdate />}
              />
              <Route
                path="/subscription_management/:restaurant_id"
                element={<SubscriptionManagement />}
              />
              <Route path="/" element={<HomeScreen />} />
            </Routes>
            {/*  {isActive ? null : <Footer />} */}
          </StyledRoutesContainer>
        </div>
      </main>
    </div>
  );
}

export default App;
